"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopAreaBannerContent = require("./TopAreaBannerContent");
Object.keys(_TopAreaBannerContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaBannerContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaBannerContent[key];
    }
  });
});
